import { render } from "./WithdrawAccountDetails.vue?vue&type=template&id=ef87f33a"
import script from "./WithdrawAccountDetails.vue?vue&type=script&lang=js"
export * from "./WithdrawAccountDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__